import React, {useEffect} from "react";
import {css, Theme} from "@emotion/react";
import {animated, useSpring} from "@react-spring/web";

import {calculateBaseSize, calculateRemSize, p} from "@pg-design/helpers-css";
import {elevation, flexAlignCenter} from "@pg-design/helpers-css-strings";
import {BrandBuildingIcon, CloseIcon} from "@pg-design/icons-module";
import {Message} from "@pg-design/message-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {useStateRef} from "@pg-mono/hooks";
import {useUserDevice} from "@pg-mono/user-device";

interface IProps {
    className?: string;
    bodyText: React.ReactNode;
}

export const BoosterPopover = (props: IProps) => {
    const {className, bodyText} = props;
    const [isActive, setIsActive, isActiveRef] = useStateRef(false);
    const userDevice = useUserDevice();

    const [styles] = useSpring(
        () => ({
            from: {transform: "translateY(-500px)"},
            to: {transform: "translateY(0px)"},
            config: {tension: 200, friction: 15},
            reverse: isActiveRef.current,
            delay: isActiveRef.current ? 0 : 2000
        }),
        [isActive, isActiveRef]
    );

    const onCloseIconClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsActive(false);
    };

    useEffect(() => {
        setTimeout(() => {
            setIsActive(true);
        }, 2000);
    }, []);

    return (
        <div css={containerPosition}>
            <animated.div style={{...styles, position: "fixed", zIndex: 100}}>
                <Message type="info" className={className}>
                    <div css={popoverWrapperStyle}>
                        {!userDevice.isMobile && (
                            <BrandBuildingIcon
                                size={calculateBaseSize(8).toString()}
                                wrapperType="circle"
                                wrapperColor={getThemeVariable("colors.primary")}
                                wrapperSize="6.5"
                            />
                        )}
                        {bodyText}
                    </div>
                    <CloseIcon size="1.6" css={closeIconStyle} onClick={onCloseIconClick} />
                </Message>
            </animated.div>
        </div>
    );
};

const containerPosition = (theme: Theme) => css`
    display: flex;
    position: absolute;
    right: 25rem;

    @media (min-width: ${theme.breakpoints.md}) {
        right: 36rem;
    }

    @media (min-width: ${theme.breakpoints.lg}) {
        right: 50rem;
    }
`;

const popoverWrapperStyle = (theme: Theme) => css`
    ${flexAlignCenter};
    gap: ${calculateRemSize(2)};
    flex-direction: row;
    ${p(3)};
    border-radius: ${calculateRemSize(2)};
    text-wrap: initial;
    ${elevation(4)};
    max-width: 25rem !important; // coudnt set width in other way bcs of useTransition styling from react spring
    width: 25rem;

    @media (min-width: ${theme.breakpoints.md}) {
        max-width: 36rem !important;
        width: 36rem;
    }

    @media (min-width: ${theme.breakpoints.lg}) {
        max-width: 50rem !important;
        width: 50rem;
    }
`;

const closeIconStyle = css`
    position: absolute;
    cursor: pointer;
    right: ${calculateRemSize(2)};
    top: ${calculateRemSize(2)};
`;
import React, {useEffect} from "react";
import {css, Theme} from "@emotion/react";
import {animated, useSpring} from "@react-spring/web";

import {calculateBaseSize, calculateRemSize, p} from "@pg-design/helpers-css";
import {elevation, flexAlignCenter} from "@pg-design/helpers-css-strings";
import {BrandBuildingIcon, CloseIcon} from "@pg-design/icons-module";
import {Message} from "@pg-design/message-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {useStateRef} from "@pg-mono/hooks";
import {useUserDevice} from "@pg-mono/user-device";

interface IProps {
    className?: string;
    bodyText: React.ReactNode;
}

export const BoosterPopover = (props: IProps) => {
    const {className, bodyText} = props;
    const [isActive, setIsActive, isActiveRef] = useStateRef(false);
    const userDevice = useUserDevice();

    const [styles] = useSpring(
        () => ({
            from: {transform: "translateY(-500px)"},
            to: {transform: "translateY(0px)"},
            config: {tension: 200, friction: 15},
            reverse: isActiveRef.current,
            delay: isActiveRef.current ? 0 : 2000
        }),
        [isActive, isActiveRef]
    );

    const onCloseIconClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsActive(false);
    };

    useEffect(() => {
        setTimeout(() => {
            setIsActive(true);
        }, 2000);
    }, []);

    return (
        <div css={containerPosition}>
            <animated.div style={{...styles, position: "fixed", zIndex: 100}}>
                <Message type="info" className={className}>
                    <div css={popoverWrapperStyle}>
                        {!userDevice.isMobile && (
                            <BrandBuildingIcon
                                size={calculateBaseSize(8).toString()}
                                wrapperType="circle"
                                wrapperColor={getThemeVariable("colors.primary")}
                                wrapperSize="6.5"
                            />
                        )}
                        {bodyText}
                    </div>
                    <CloseIcon size="1.6" css={closeIconStyle} onClick={onCloseIconClick} />
                </Message>
            </animated.div>
        </div>
    );
};

const containerPosition = (theme: Theme) => css`
    display: flex;
    position: absolute;
    right: 25rem;

    @media (min-width: ${theme.breakpoints.md}) {
        right: 36rem;
    }

    @media (min-width: ${theme.breakpoints.lg}) {
        right: 50rem;
    }
`;

const popoverWrapperStyle = (theme: Theme) => css`
    ${flexAlignCenter};
    gap: ${calculateRemSize(2)};
    flex-direction: row;
    ${p(3)};
    border-radius: ${calculateRemSize(2)};
    text-wrap: initial;
    ${elevation(4)};
    max-width: 25rem !important; // coudnt set width in other way bcs of useTransition styling from react spring
    width: 25rem;

    @media (min-width: ${theme.breakpoints.md}) {
        max-width: 36rem !important;
        width: 36rem;
    }

    @media (min-width: ${theme.breakpoints.lg}) {
        max-width: 50rem !important;
        width: 50rem;
    }
`;

const closeIconStyle = css`
    position: absolute;
    cursor: pointer;
    right: ${calculateRemSize(2)};
    top: ${calculateRemSize(2)};
`;
